module.exports = __webpack_public_path__ + "static/media/DM2Simi3.c2e06f57.png";